export default __webpack_public_path__ + "static/media/CV4.095babfd.png";